export class PopUpHelper{


  public static confirmPopUp(message: string): boolean{
    return confirm(message);
  }

  public static alertPopUp(message: string): boolean{
    return confirm(message);
  }

}
